"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonVaccineProofs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const Formatters_1 = require("../../common/Formatters");
const hui_1 = require("@mit/hui");
const executeSortDesc = (a, b) => {
    const fieldName = 'start_datetime';
    let dateTimeA = (0, Formatters_1.toDate)(a[fieldName]);
    let dateTimeB = (0, Formatters_1.toDate)(b[fieldName]);
    return dateTimeB.diff(dateTimeA);
};
const PersonVaccineProofsComponent = ({ searchUser, mitId, roles }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [data, setData] = (0, react_1.useState)([]);
    const [vaccineType, setVaccineType] = (0, react_1.useState)([]);
    const [vaccineCompany, setVaccineCompany] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        initialiseData();
    }, []);
    /*   useEffect(() => {
        if(mitId || searchUser && searchUser.person) {
          initialiseData()
        }
      }, [searchUser!.person, mitId]); */
    const initialiseData = () => {
        setIsLoading(true);
        Promise.all([
            MedicalApi_1.default.fetchVaccineCompanies(),
            MedicalApi_1.default.fetchVaccineTypes(),
            MedicalApi_1.default.fetchPersonVaccineProofs(mitId ? mitId : searchUser.person.mitId)
        ]).then(([company, vaccineType, vaccineProof]) => {
            setVaccineType(vaccineType);
            setVaccineCompany(company);
            remapProofs(vaccineProof.items || [], company);
            setIsLoading(false);
        });
    };
    const remapProofs = (vaccineProofs, vaccineProof) => {
        let remapped = vaccineProofs.map((proof) => {
            var _a;
            const companyName = vaccineProof.find((company) => company.medical_vaccine_company_guid === proof.company);
            return Object.assign(Object.assign({}, proof), { vaccine_status: (_a = vaccineStatus(proof.status)) === null || _a === void 0 ? void 0 : _a.status, vaccine_type: proof.shots.length >= 2 ? `${companyName.company_name} (Dose ${proof.shots[0].shot_number} & Dose ${proof.shots[1].shot_number})` : `${companyName.company_name} (Dose ${proof.shots[0].shot_number})`, vaccine_date: (0, Formatters_1.displayDate)(proof.shots[0].received_on) });
        });
        setData(remapped);
    };
    const vaccineStatus = (status) => {
        let vaccineStatus = {
            P: { status: "Pending", color: "status-pending" },
            A: { status: "Approved", color: "status-approved" },
            R: { status: "Rejected", color: "status-rejected" }
        };
        return vaccineStatus[status];
    };
    const columns = [
        {
            id: "vaccine_type",
            name: "Vaccine Type",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Vaccine Type"
            },
            filterable: false
        },
        {
            id: "vaccine_date",
            name: "Recieved On",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Recieved On"
            },
            filterable: false
        },
        {
            id: "vaccine_status",
            name: "Status",
            sortable: true,
            formatter: (item) => {
                var _a;
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: ` ${(_a = vaccineStatus(item.status)) === null || _a === void 0 ? void 0 : _a.color}` }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.vaccine_status }) })));
            },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Vaccine Status"
            },
            filterable: false
        },
    ];
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", Object.assign({ className: "covid-19-vaccine-proofs profile-table-headers" }, { children: "Vaccine Proof(s) Uploaded." })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'person-detail-container' }, { children: (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, maxRows: 1000, items: data, isLoading: isLoading, sortStateOptions: {
                        enabled: true,
                        key: 'covid-medical-person-vaccine-proofs'
                    } }) }))] });
};
exports.PersonVaccineProofs = (0, mobx_react_1.inject)('searchUser', 'roles')((0, mobx_react_1.observer)(PersonVaccineProofsComponent));
